/* eslint-disable import/prefer-default-export */
import styled from "styled-components";

// Note: the width is 100% so the actual width (e.g. 600px) you want for the
// PDF page should be set within whatever parent you are using. Then
// the DocumentWrapper will be 100% of 600px;
export const DocumentWrapper = styled.div`
  width: 100%;
`;
